import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { InvoiceSetupContainerComponent } from './invoice-setup-container/invoice-setup-container.component';
// import * as fromInvoice from '.';

const log = new LoggingService();

export const InvoiceSetupRoute: Ng2StateDeclaration = {
    // name: 'invoice.**'
    name: 'invoice.setup',
    url: '/setup',
    // , loadChildren: () => import('./payroll-item.module').then(r => r.invoiceModule)
    data: { requiresAuth: true },
    component: InvoiceSetupContainerComponent
};
